// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"b5897a33","249":"240d6ac4","386":"022c57dd","453":"458edbb8","892":"c4f81249","905":"5b3ff84e","984":"f7f223a6"}[chunkId] + ".chunk.js";
};